import React from "react";

export type FormularioModalTab = "configuracion" | "identidad-visual";

interface FormularioModalTabsProps {
  active: FormularioModalTab;
  onChange: (tab: FormularioModalTab) => void;
  logoEnabled: boolean;
  logoLoading?: boolean;
  themeCustomized?: boolean;
}

const tabs: Array<{ id: FormularioModalTab; label: string; description: string }> = [
  { id: "configuracion", label: "Configuración", description: "Campos y contenido" },
  { id: "identidad-visual", label: "Identidad visual", description: "Logo y presentación" },
];

const FormularioModalTabs = ({ active, onChange, logoEnabled, logoLoading = false, themeCustomized = false }: FormularioModalTabsProps) => (
  <div
    role="tablist"
    aria-label="Secciones del formulario"
    style={{
      display: "flex",
      gap: "4px",
      padding: "10px 24px 0",
      background: "#fff",
      borderBottom: "1px solid #e2e8f0",
    }}
  >
    {tabs.map((tab) => {
      const selected = active === tab.id;
      const showStatus = tab.id === "identidad-visual" && (logoLoading || logoEnabled || themeCustomized);
      return (
        <button
          key={tab.id}
          type="button"
          role="tab"
          id={`form-modal-tab-${tab.id}`}
          aria-selected={selected}
          aria-controls={`form-modal-panel-${tab.id}`}
          tabIndex={selected ? 0 : -1}
          onClick={() => onChange(tab.id)}
          onKeyDown={(event) => {
            if (event.key !== "ArrowLeft" && event.key !== "ArrowRight") return;
            event.preventDefault();
            const next = tab.id === "configuracion" ? "identidad-visual" : "configuracion";
            onChange(next);
            window.requestAnimationFrame(() => document.getElementById(`form-modal-tab-${next}`)?.focus());
          }}
          style={{
            position: "relative",
            minWidth: "168px",
            padding: "9px 14px 11px",
            border: "none",
            borderRadius: "9px 9px 0 0",
            background: selected ? "#eff6ff" : "transparent",
            color: selected ? "#0050b3" : "#64748b",
            cursor: "pointer",
            fontFamily: "Roboto, sans-serif",
            textAlign: "left",
            transition: "background 0.15s, color 0.15s",
          }}
        >
          <span style={{ display: "flex", alignItems: "center", gap: "7px", fontSize: "13px", fontWeight: 700 }}>
            {tab.label}
            {showStatus && (
              <span
                aria-label={logoLoading ? "Cargando identidad visual" : "Identidad visual activa"}
                title={logoLoading ? "Cargando identidad visual" : "Identidad visual activa"}
                style={{
                  width: "7px",
                  height: "7px",
                  borderRadius: "50%",
                  background: logoLoading ? "#f59e0b" : "#10b981",
                  boxShadow: `0 0 0 3px ${logoLoading ? "rgba(245,158,11,.14)" : "rgba(16,185,129,.14)"}`,
                }}
              />
            )}
          </span>
          <span style={{ display: "block", marginTop: "2px", fontSize: "10.5px", fontWeight: 400, color: selected ? "#3b6f9f" : "#94a3b8" }}>
            {tab.description}
          </span>
          {selected && <span aria-hidden="true" style={{ position: "absolute", left: 10, right: 10, bottom: -1, height: "2px", borderRadius: "2px", background: "#0065DD" }} />}
        </button>
      );
    })}
  </div>
);

export default FormularioModalTabs;
